<template>
  <div class="dialog-split-account-review">
    <el-dialog title="审核分账比例" width="30%" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <el-form label-position="left" label-width="80px" ref="slpitAccountForm" :rules="splitAccountRules" :model="splitAccountForm">
        <el-form-item
          label="主账号"
          prop="main_account"
          v-if="reviewingAccount.apply_rule && reviewingAccount.apply_rule.length > 0">
          <el-input-number
            v-model="reviewingAccount.apply_rule[0].split_percent"
            controls-position="right"
            :min="0"
            :max="100"></el-input-number> % <br/>
          客户申请比例: {{ reviewingAccount.split_percent }}%
        </el-form-item>
        <el-form-item
          v-for="(account, i) in reviewingAccount.split_account"
          :key="i"
          label="子账号"
          :prop="`subaccount-${i}`"
          v-if="reviewingAccount.apply_rule && reviewingAccount.apply_rule.length > i + 1">
          <el-input-number
            v-model="reviewingAccount.apply_rule[i+1].split_percent"
            controls-position="right"
            :min="0"
            :max="100"></el-input-number> % <br/>
          客户申请比例{{ i }}: {{ account.split_percent }}%
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onReviewSubmit">确定</el-button>
          <el-button @click="onReviewCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DialogSplitAccountReview',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    reviewingAccount: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      splitAccountForm: {
      },
      splitAccountRules: {
      }
    }
  },
  methods: {
    onDialogOpen () {
      const lackLen = this.reviewingAccount.split_account.length + 1 - this.reviewingAccount.apply_rule.length
      if (lackLen > 0) {
        for (let i = 0; i < lackLen; i++) {
          // apply_rule is lack
          this.reviewingAccount.apply_rule.push({
            account: 'sub_account',
            split_percent: 0
          })
        }
      }
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    },
    async onReviewSubmit () {
      try {
        const cleanRule = []
        for (let i = 0; i < this.reviewingAccount.apply_rule.length; i++) {
          if (i === 0) {
            cleanRule.push({
              account: 'main_account',
              split_percent: parseInt(this.reviewingAccount.apply_rule[i].split_percent)
            })
          } else {
            cleanRule.push({
              account: 'sub_account',
              split_percent: parseInt(this.reviewingAccount.apply_rule[i].split_percent)
            })
          }
        }

        await this.passSplitAccount({
          splitAccountId: this.reviewingAccount.split_account_id,
          applyRule: cleanRule,
          status: this.reviewingAccount.status
        })
        this.$message({
          type: 'success',
          message: '审核成功'
        })
        this.$emit('update:visible', false)
        this.$emit('data-change')
      } catch (err) {
        this.$message({
          type: 'error',
          message: '审核失败'
        })
        console.log(err)
      }
    },
    onReviewCancel () {
      this.$emit('update:visible', false)
    },
    ...mapActions('bank', [
      'passSplitAccount'
    ])
  }
}
</script>

<style lang="scss" scoped>
.dialog-split-account-review {
  .el-input {
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bank/DialogSplitAccountReview.vue